var _ellipse, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBnplInprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.5,
    cy: 9.05284,
    rx: 8.5,
    ry: 8.94737,
    fill: "#EB9928"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1773 5.68634C9.77109 5.31218 9.13846 5.33817 8.7643 5.7444C8.39014 6.15063 8.41614 6.78327 8.82237 7.15743L9.93806 8.18504L5 8.18504C4.44772 8.18504 4 8.63275 4 9.18504C4 9.73732 4.44772 10.185 5 10.185L9.93806 10.185L8.82237 11.2127C8.41614 11.5868 8.39014 12.2194 8.7643 12.6257C9.13846 13.0319 9.77109 13.0579 10.1773 12.6837L13.1773 9.92058C13.3829 9.73124 13.4998 9.46452 13.4998 9.18504C13.4998 8.90556 13.3829 8.63883 13.1773 8.44949L10.1773 5.68634Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnplInprogress);
export default __webpack_public_path__ + "static/media/bnpl-inprogress.3358c635.svg";
export { ForwardRef as ReactComponent };